<div class="social-media-container">
  <p class="text">Nossas Redes Sociais</p>
  <div class="social-media-icons">
    <a *ngFor="let social of socialLinks" [href]="social.url" target="_blank" rel="noopener noreferrer">
      <img [src]="social.icon" [alt]="social.name" class="social-icon" />
    </a>
  </div>
</div>
